export const AUTH_SESSION_ERRORS = [
    'no-token',
    'unavailable-token',
    'invalid-token',
    'jwt-error',
    'account-not-found'
];

export const isAuthSessionError = message =>
    AUTH_SESSION_ERRORS.includes(message);

// account-not-found también se usa como resultado comercial. El HTTP 401 es
// lo que permite identificarlo de forma inequívoca como una sesión inválida.
export const isAuthSessionResponse = (status, message) =>
    status === 401 && isAuthSessionError(message);

export const clearStoredSession = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('token-date');
    localStorage.removeItem('cart-token');
};
